import React from "react";
import Masonry from "react-masonry-css";

const breakpointColumnsObj = {
  default: 4,
  1024: 3,
  640: 2,
  0: 1,
};

const cardHeights = [260, 340, 300, 380, 280, 360, 320, 400];

function CatalogoSkeleton() {
  return (
    <div className="animate-pulse">
      <header className="bg-white p-6 max-w-4xl mx-auto flex flex-col items-center gap-6">
        <div className="w-24 h-24 rounded-full bg-gray-200" />
        <div className="w-full max-w-xl text-center">
          <div className="h-8 w-2/3 bg-gray-200 rounded mx-auto mb-3" />
          <div className="h-5 w-1/2 bg-gray-200 rounded mx-auto mb-5" />
          <div className="flex justify-center gap-3">
            <div className="w-8 h-8 bg-gray-200 rounded-full" />
            <div className="w-8 h-8 bg-gray-200 rounded-full" />
            <div className="w-8 h-8 bg-gray-200 rounded-full" />
            <div className="w-8 h-8 bg-gray-200 rounded-full" />
          </div>
        </div>
      </header>

      <div className="w-full max-w-[1600px] mx-auto px-2 sm:px-4 mt-2">
        <div className="flex flex-col items-center gap-2 mb-4 w-full max-w-3xl mx-auto">
          <div className="w-full h-10 bg-gray-200 rounded-lg" />
          <div className="w-full h-10 bg-gray-200 rounded-lg" />
        </div>

        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="flex gap-4"
          columnClassName="flex flex-col gap-4"
        >
          {cardHeights.map((height, idx) => (
            <div
              key={idx}
              className="w-full bg-gray-200 rounded-xl shadow-sm"
              style={{ height }}
            />
          ))}
        </Masonry>
      </div>

      <footer className="bg-gray-100 mt-16 py-6 px-4 border-t border-gray-200">
        <div className="max-w-5xl mx-auto">
          <div className="flex justify-between items-start gap-6">
            <div className="space-y-2 w-full max-w-xs">
              <div className="h-4 w-2/3 bg-gray-200 rounded" />
              <div className="h-3 w-full bg-gray-200 rounded" />
              <div className="h-3 w-1/2 bg-gray-200 rounded" />
            </div>
            <div className="flex gap-3">
              <div className="w-7 h-7 bg-gray-200 rounded-full" />
              <div className="w-7 h-7 bg-gray-200 rounded-full" />
              <div className="w-7 h-7 bg-gray-200 rounded-full" />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CatalogoSkeleton;

